export default __webpack_public_path__ + "static/media/after like.f51d2dc5.png";